import {
  SHOW_SPINNER,
  HIDE_SPINNER,
  API_ERROR,
  SET_APP_MODE,
  SET_APP_MODULE,
  SET_COMMON_SOUNDS,
  SHOW_FORWARD_BUTTON,
  HIDE_FORWARD_BUTTON,
  SET_PULSE_TIMESTAMP,
  SET_MIC_PERMISSIONS,
  SET_MOBILE,
  CLEAR_COMMON_SOUNDS,
  SET_ACTIVITY_TIMESTAMP,
  SHOW_VISUAL_CUE,
  HIDE_VISUAL_CUE,
  SET_LITE_VERSION,
  SET_ACCESSIBILITY_MODE
} from '../types/ui';

export const initialState = {
  loading: false,
  apiError: null,
  isMobile: false,
  appMode: 'curriculum',
  module: '',
  sounds: {
    common: {}
  },
  forwardButton: {
    show: false,
    pulseTimeStamp: 0,
    isDone: false
  },
  micPermissions: true,
  activityTimestamp: 0,
  successErrorMessage: {
    show: false,
    message: ''
  },
  isLiteVersion: false,
  hasAccessibilityMode: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SPINNER:
      return { ...state, loading: true };

    case HIDE_SPINNER:
      return { ...state, loading: false };

    case SET_APP_MODE:
      return { ...state, appMode: action.payload };

    case SET_APP_MODULE:
      return { ...state, module: action.payload };
    case SET_MOBILE:
      return { ...state, isMobile: action.payload };

    case SET_COMMON_SOUNDS:
      return {
        ...state,
        sounds: {
          ...state.sounds,
          // common: { ...state.sounds.common, ...action.payload }
          common: action.payload
        }
      };

    case CLEAR_COMMON_SOUNDS:
      return {
        ...state,
        sounds: {
          ...state.sounds,
          common: {}
        }
      };

    case SHOW_FORWARD_BUTTON:
      return {
        ...state,
        forwardButton: {
          ...state.forwardButton,
          show: true,
          isDone: true
        }
      };

    case HIDE_FORWARD_BUTTON:
      return { ...state, forwardButton: { ...initialState.forwardButton } };

    case SET_PULSE_TIMESTAMP:
      return {
        ...state,
        forwardButton: {
          ...state.forwardButton,
          pulseTimeStamp: action.payload
        }
      };

    case SET_MIC_PERMISSIONS:
      return { ...state, micPermissions: action.payload };

    case API_ERROR:
      return { ...state, apiError: action.payload };

    case SET_ACTIVITY_TIMESTAMP:
      return { ...state, activityTimestamp: action.payload };

    case SHOW_VISUAL_CUE:
      return {
        ...state,
        successErrorMessage: {
          ...state.successErrorMessage,
          show: true,
          message: action.payload
        }
      };

    case HIDE_VISUAL_CUE:
      return {
        ...state,
        successErrorMessage: {
          ...state.successErrorMessage,
          show: false,
          message: ''
        }
      };

    case SET_LITE_VERSION:
      return { ...state, isLiteVersion: action.payload };

    case SET_ACCESSIBILITY_MODE:
      return { ...state, hasAccessibilityMode: action.payload };

    default:
      return state;
  }
};
